__turbopack_context__.v({
  "root": "DesktopTableNew-module__e5xd4G__root",
});
